import React from "react";
import Fade from "react-reveal/Fade";
import "./BlogCard.scss";

interface BlogCardProps {
  title: string;
  date: string;
  author: string;
  image: string;
  link: string;
}

const BlogCard = (props: BlogCardProps) => {
  const { title, date, author, image, link } = props;
  return (
    <Fade bottom>
      <div className="col-lg-6 col-xl-3 col-md-6 col-sm-12 mt-5">
        <div className="blog">
          <div className="inner">
            <div className="thumbnail text-center">
              <img
                loading="lazy"
                className="img-fluid"
                src={image}
                alt="thumbnail"
              />
            </div>
            <div className="content">
              <div className="meta-info">
                <span className="date">{date}</span>
                <span className="author">
                  <i className="bi bi-person-fill">&nbsp;</i>
                  {author}
                </span>
              </div>
              <h1 className="title">
                <a href={link} target="_blank" rel="noreferrer">
                  {title}
                </a>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
};

export default BlogCard;
